import PropTypes from 'prop-types';
import React from 'react';
import UnderlineNavigation from '../../Elements/UnderlineNavigation/UnderlineNavigation';

import './TitleWithUnderlineSubnav.scss';

export default class TitleWithUnderlineSubnav extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        title: PropTypes.string,
        menuItems: PropTypes.arrayOf(
            PropTypes.shape({
                text: PropTypes.string,
                url: PropTypes.string,
                active: PropTypes.bool,
                total: PropTypes.number,
            })
        ),
    };

    static defaultProps = {
        title: '',
        menuItmes: [],
    };

    render() {
        return (
            <div className="component-Layout-TitleWithUnderlineSubnav">
                <div className="title-text-display">{this.props.title}</div>
                <UnderlineNavigation menuItems={this.props.menuItems} />
            </div>
        );
    }
}
